import { Component } from '@angular/core';

import { ReportsService } from '../../../services/reports.service';

@Component({
  selector: 'custom-status-bar-filtered-count',
  template: `
    <div
      *ngIf="
        rptService.ssrTotalRowsData.filtered &&
        rptService.ssrTotalRowsData.filtered !== rptService.ssrTotalRowsData.total
      "
      style="padding: 8px"
    >
      <span>{{ 'AGGRIDLOCALE.filteredRows' | translate }}:&nbsp;</span>
      <span style="color: black">{{ rptService.ssrTotalRowsData.filtered }}</span>
    </div>
  `,
  styles: [],
})
export class CustomStatusBarFilteredCountComponent {
  constructor(public rptService: ReportsService) {}

  agInit(): void {}
}
